import { Logo } from './Logo';

/**
 * Shared site footer rendered on every page (public pages + the authenticated
 * Layout). Black-and-white minimalist, mobile-first. Each link uses a stable
 * `data-testid` so existing E2E tests targeting the landing footer keep working.
 */
export default function Footer() {
    return (
        <footer
            className="border-t border-zinc-200 px-6 py-8 bg-white mt-auto"
            data-testid="site-footer"
        >
            <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
                <Logo size="sm" data-testid="footer-logo" />
                <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-zinc-900">
                    <a href="/faq" className="hover:opacity-70 underline" data-testid="footer-faq-link">FAQ</a>
                    <a href="/about" className="hover:opacity-70 underline" data-testid="footer-about-link">About Us</a>
                    <a href="/contact" className="hover:opacity-70 underline" data-testid="footer-contact-link">Contact</a>
                    <a href="/terms" className="hover:opacity-70 underline" data-testid="footer-terms-link">Terms of Service</a>
                    <a href="/privacy" className="hover:opacity-70 underline" data-testid="footer-privacy-link">Privacy Policy</a>
                    <span className="hidden sm:inline">The Gulf's specialist platform for blue collar hiring</span>
                </div>
            </div>
        </footer>
    );
}
